import settings from '../settings.js'

const $inject = ['$scope', 'common', 'SurveyService', 'UserService', '$ionicConfig', '$ionicScrollDelegate', '$state', '$stateParams', '$ionicPopup']

function UserCtrl(scope, common, SurveyService, UserService, ionicConfig, ionicScrollDelegate, state, stateParams, ionicPopup) {
    scope.settings = settings;

    scope.setLanguage = UserService.setLanguage;
    scope.getLangCode = UserService.getLangCode;

    //On language change, also change the text of the ionic back button.
    scope.$on('language.changed', (event, newLangCode) => {
        ionicConfig.backButton.text(_locale('back').ucfirst());
    });

    const contactDetails = {
        surveyElementId: 385,
        type: "contactDetails",
        options: ["phone", "address"],
        mailingList: 0,
        askMailingListPermission: false,
        permissionQuestion: _locale("add me to newsletter").ucfirst(),
        consentQuestion: _locale("I accept the terms of use").ucfirst() //Default 
    };

    if (UserService.usePersonDateOfBirth)
        contactDetails.options.push("dateOfBirth");

    if (UserService.usePersonGuardian)
        contactDetails.options.push("guardianCheck");

    SurveyService.baseUrl = settings.baseUrl;

    if (stateParams.mode === 'registration') {
        SurveyService.getConsentCheckboxText((response) => {
            contactDetails.consentQuestion = response;
        });

        contactDetails.options.push("password");

        contactDetails.isRegistration = true;
        contactDetails.mailingList = settings.registerMailingLists;
        contactDetails.askMailingListPermission = true;
        contactDetails.permissionQuestion = _locale("add me to newsletter").ucfirst();

        scope.injectAnswers = {
            contactDetails: {
                country: 'FI'
            }
        };
    }

    scope.signUpInStatus = 0; // 1 = loading, 2 = success

    scope.survey = {
        "surveyId": 52,
        "surveyName": "Appsi rekister\u00f6ityminen",
        "inviteOnly": false,
        "onlyForRegisteredUsers": false,
        "settings": {
            "surveyStyle": "none",
            "sendButton": stateParams.mode === 'registration' ? _locale('register').ucfirst() : _locale('save').ucfirst()
        },
        "elements": [
            contactDetails
        ]
    };

    function init() {
        if (stateParams.mode === 'userdetails') {
            const contactDetails = {
                firstName: UserService.user.firstName,
                familyName: UserService.user.lastName,
                email: UserService.user.username,
                phone: UserService.user.phone,
                streetAddress: UserService.user.streetAddress,
                postalCode: UserService.user.postalCode,
                city: UserService.user.city                
            };

            if (UserService.usePersonDateOfBirth) {
                contactDetails.dateOfBirth = null;
                const dobMoment = moment(UserService.user.dateOfBirth, 'YYYY-MM-DD');

                //Check if dob is valid. Avoid "Invalid date" error caused by 0000-00-00 from db.
                if (UserService.user.dateOfBirth && dobMoment.isValid())
                    contactDetails.dateOfBirth = dobMoment.format('DD.MM.YYYY');
            }           

            if (UserService.usePersonGuardian) {
                contactDetails.guardianName = UserService.user.guardianName;
                contactDetails.guardianSSN = UserService.user.guardianSSN;
            }

            scope.injectAnswers = {
                contactDetails: contactDetails
            };
        }
    }

    scope.saveUserDetails = (survey) => {
        const answers = survey.answers.contactDetails;

        scope.signUpInStatus = 1;

        UserService
            .changeUserDetails(answers)
            .then((response) => {
                if (response.data.success) {
                    const newSetDetails = {
                        username: response.data.email,
                        firstName: response.data.firstName,
                        lastName: response.data.familyName,
                        phone: response.data.phone,
                        streetAddress: response.data.streetAddress,
                        postalCode: response.data.postalCode,
                        city: response.data.city
                    };

                    if (UserService.usePersonDateOfBirth)
                        newSetDetails.dateOfBirth = response.data.dateOfBirth;

                    if (UserService.usePersonGuardian) {
                        newSetDetails.guardianName = response.data.guardianName;
                        newSetDetails.guardianSSN = response.data.guardianSSN;
                    }

                    UserService.setDetails(newSetDetails);

                    scope.signUpInStatus = 2;
                    state.go('app.account', {}, { reload: true });
                }
                else {
                    if (response.data.errors) {
                        scope.survey.elements[0].error = true;
                        scope.survey.elements[0].errorMessage = response.data.errors.join(' ');
                    }

                    scope.signUpInStatus = 0;
                }
            }, () => {
                scope.signUpInStatus = 0;
                errorAndRedirect(_locale('error while saving').ucfirst())
            });
    };

    scope.register = (survey) => {
        const answers = survey.answers.contactDetails;

        const doRegister = () => { //Finish registration
            scope.signUpInStatus = 1;

            const loginSuccess = (response) => {
                if (response.data.access_token)
                    common.log("Logged in user " + UserService.user.username + ". Using sessionId: " + response.data.access_token, true);

                scope.$emit('User:loginSuccessAction');
            };

            const loginFail = (response) => {
                errorAndRedirect(_locale('error during login').ucfirst());
            };

            UserService.registerUser(answers).then((response) => {
                if (response.data.success) {
                    UserService.authorize(answers.email, answers.password).then(loginSuccess, loginFail);
                    scope.signUpInStatus = 2;
                }
                else {
                    scope.survey.elements[0].error = true;
                    scope.survey.elements[0].errorMessage = response.data.errors.join(' ');
                    scope.signUpInStatus = 0;
                }
            }).catch((response) => {
                scope.signUpInStatus = 0;
                errorAndRedirect(_locale('error during registration').ucfirst());
            });
        };

		doRegister();
    };

    function errorAndRedirect(title) {
        const popupPromise = ionicPopup.show({
            title: title,
            subTitle: _locale('please try again').ucfirst(),
            scope: scope,
            buttons: [
                { text: 'OK' }
            ]
        });
        
        popupPromise.then(() => {
            state.go(settings.stateFront);
        });

        common.ionicPopupHandler(popupPromise, 3000);
    }

    scope.$on('wnsurvey.resize', () => {
        ionicScrollDelegate.resize();
    });
    
    scope.$on('$ionicView.beforeEnter', init);
}

UserCtrl.$inject = $inject

export default UserCtrl